import React from 'react';
import Helmet from "react-helmet";
import DiscountInclude from '../../components/includes/discountInclude';
import PaymentMethodsInclude from '../../components/includes/paymentMethodsInclude';
import FeatureSlider from './featureSlider';
import ReactDependentScript from "react-dependent-script";
import DiscountCounter from './dscountCounter';
import AppList from './appsList';
import ProtocolsList from './protocolsList';
import OffshoreSwitzerland from '../offshore-hosting/offshoreSwitzerland';


class VPNoffshore extends React.Component {

	render() {

		const protocol = 'all'

		return (
			<React.Fragment>
				<Helmet>
					<title>Offshore VPN in Switzerland - Dedicated IP &amp; Private Server | Swiss Made Host</title>
					<meta name="description" content="Private no-logs VPN is a high security virtual key to your offshore Swiss residency that protects identity, enables access to geo-restricted content and improves secrutiy of your browsing." />
					<link rel="canonical" href="https://swissmade.host/en/offshore-vpn" />
				</Helmet>
				<div className="fullwidth pic vpn">
					<div className="row">
						<div className="twelve columns">
							<div className="transparent">
								<h1 className="title">Offshore <span>VPN Server</span></h1>
								<h2>A High Security Key to Your Offshore Swiss Residence</h2>
							</div>
						</div>
					</div>
				</div>
				<DiscountInclude />
				<OffshoreSwitzerland />
				<ProtocolsList protocol={protocol}/>
				<ReactDependentScript scripts={["/js/jquery-3.4.1.js"]}>
					<FeatureSlider protocol={protocol} />
				</ReactDependentScript>
				<DiscountCounter protocol={protocol}/>
				<AppList protocol={protocol}/>
				<PaymentMethodsInclude />
			</React.Fragment>
		)
	}
	toggleAnimation = (e) => {
		document.getElementById('ddos-protection-info').classList.toggle('expanded')
	}
}

export default VPNoffshore;